import React from 'react'
import Box from '@material-ui/core/Box'
import { useEffectOnce } from 'react-use'
import styled from 'styled-components'
import { customTheme } from '../../../libraries/MaterialUI'

const Root = styled(Box)`
  margin: ${customTheme.spacing(0, 1)};
`

interface InputDetailsViewProps {
  handleSubmit: () => Promise<void>
}

const Component: React.FC<InputDetailsViewProps> = ({ handleSubmit }) => {
  useEffectOnce(() => {
    handleSubmit()
  })
  return <Root />
}

export default Component
